import { render, staticRenderFns } from "./GitDiffFolder.vue?vue&type=template&id=2c5cf0cc&scoped=true"
import script from "./GitDiffFolder.vue?vue&type=script&lang=js"
export * from "./GitDiffFolder.vue?vue&type=script&lang=js"
import style0 from "./GitDiffFolder.vue?vue&type=style&index=0&id=2c5cf0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5cf0cc",
  null
  
)

export default component.exports